module.exports = __webpack_public_path__ + "img/市场助手.186e4f04.png";